export class AuthConfig {
	authUrl: string;
	refreshTokenUrl: string;
	loginRoute: string;
}
